import googleIcon from "assets/icons/google-icon.svg";
import yandexIcon from "assets/icons/yandex.png";

import help from "assets/icons/help.svg";
import { gapi } from "gapi-script";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import PinCode from "hooks/PinCode/PinCode";
import ButtonLoader from "hooks/UseLoading/ButtonLoader";
import useLoading from "hooks/UseLoading/UseLoading";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import eye from "assets/icons/eye.png";
import hidden from "assets/icons/hidden.png";
import {
  ChangePin,
  getEmailDatacor,
  getUserInfo,
  login,
  logintrash,
  postToMail,
  checkPinCode,

} from "service/AuthService";
import DriverRegistrationForm from "components/Forms/DriverRegistrationForm/DriverRegistrationForm";

import { getImage } from "service/BackgroundService";

import { changePinCode, postMail, setUser } from "store/slices/UserSlice";
import Notification from "utils/Notifications";
import tokenDecode from "utils/decode";
import { ScaleLoader } from "react-spinners";
import rostok from "assets/icons/rostok.png";
import { Button } from "components";



import styles from "./LoginForm.module.scss";


import { YandexLogin } from 'react-yandex-login';

const clientID = '187efcae240d4cadae5fcd470868203b';

function LoginForm() {
  //UseState
  const [loader, setLoader] = useState(false);
  const [loginMail, setLoginMail] = useState(false);
  const [showDriverReg, setShowDriverReg] = useState(false);
  const [recoverPassword, setRecoverPassword] = useState(false);
  const [recoverPin, setRecoverPin] = useState(false);

  const [userPinCode, setUserPinCode] = useState();
  const [pinCode, setPinCode] = useState();
  const [userId, setUserId] = useState();
  const [email, setEmail] = useState("");
  const [emailCor, setEmailCor] = useState("");
  const [device, setDevice] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  
  // PWA Install states
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);
  //TEST GOOGLE

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    setDevice(userAgent);
  }, []);

  // PWA Install handler
  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setShowInstallButton(false);
    }

    // iOS detection
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isStandalone = window.navigator.standalone;
    
    if (isIOS && !isStandalone) {
      setShowInstallButton(true);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isMacOS = /Macintosh/.test(navigator.userAgent);
    
    // iOS - показать инструкцию
    if (isIOS) {
      setNotify({
        isOpen: true,
        message: "Нажмите кнопку 'Поделиться' ⎙ внизу экрана, затем выберите 'На экран Домой'",
        type: "info",
        sound: "info",
      });
      return;
    }

    // Desktop (PC/Mac) - показать инструкцию для закладки
    if (!deferredPrompt) {
      if (window.navigator.userAgent.indexOf('Chrome') !== -1 || window.navigator.userAgent.indexOf('Edg') !== -1) {
        setNotify({
          isOpen: true,
          message: "Нажмите Ctrl+D (Windows) или Cmd+D (Mac) чтобы добавить в закладки, или используйте меню браузера → Закладки → Добавить закладку",
          type: "info",
          sound: "info",
        });
      } else if (window.navigator.userAgent.indexOf('Firefox') !== -1) {
        setNotify({
          isOpen: true,
          message: "Нажмите Ctrl+D (Windows) или Cmd+D (Mac) чтобы добавить в закладки",
          type: "info",
          sound: "info",
        });
      } else if (window.navigator.userAgent.indexOf('Safari') !== -1 && !isIOS) {
        setNotify({
          isOpen: true,
          message: "Нажмите Cmd+D чтобы добавить в закладки, или откройте меню Закладки → Добавить закладку",
          type: "info",
          sound: "info",
        });
      } else {
        setNotify({
          isOpen: true,
          message: "Используйте меню браузера для добавления сайта в закладки",
          type: "info",
          sound: "info",
        });
      }
      return;
    }

    // Android/Chrome - PWA установка
    try {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      
      if (outcome === 'accepted') {
        setNotify({
          isOpen: true,
          message: "Приложение успешно установлено!",
          type: "success",
          sound: "success",
        });
        setShowInstallButton(false);
      }
      
      setDeferredPrompt(null);
    } catch (error) {
      console.error('Installation failed:', error);
      setNotify({
        isOpen: true,
        message: "Не удалось установить приложение",
        type: "error",
        sound: "error",
      });
    }
  };

  //Dispatch & Navigate
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let data;
  //МОДАЛКА
  const [openModal, setOpenModal] = useState(false);
  const [datainfo, setDataInfo] = useState(false);

  let socket = null;

  const sendMessage = (message) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(message);
    } else {
      console.log("onoxo");
      // Handle the case when the socket is not open
    }
  };

  //Notifications
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  //UseSelector
  const user = useSelector((state) => state.user);

  const { loading, withLoading } = useLoading(false);
  //Functions
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (email === "") {
      setNotify({
        isOpen: true,
        message: "Введите ИНН!",
        type: "warning",
        sound: "warning",
      });
    } else {
      try {
        await withLoading(async () => {
          // Шаг 1: Логин по username (ИНН)
          let response = await login(email);
          
          console.log('Login response:', response.data); // Debug
          
          if (!response.data.access || !response.data.refresh) {
            throw new Error('Токены не получены от сервера');
          }
          
          // Шаг 2: Декодируем refresh токен для получения userId
          const userId = tokenDecode(response.data.refresh);
          console.log('Decoded userId:', userId); // Debug
          
          // Шаг 3: Сохраняем access токен в localStorage
          localStorage.setItem("token", response.data.access);

          // Шаг 4: Получаем информацию о пользователе (используется токен из localStorage)
          let userResponse = await getUserInfo(userId);
          const data = { ...userResponse.data, token: response.data.access };

          //урезал код
          setUserPinCode(data.pin);
          setDataInfo(data)
          setOpenModal(true);
          setUserId(userId);
        });
      } catch (error) {
        console.error('Login error:', error); // Debug
        setNotify({
          isOpen: true,
          message:
            error.response?.data?.detail ||
            error.message ||
            "Ошибка входа",
          type: "error",
          sound: "error",
        });
      }
    }
  };
 

  const signIn = async (event) => {
    event.preventDefault();
    const _auth0k = (googleUser) => {
      const emails = googleUser.getBasicProfile().getEmail();
      var auth2 = gapi.auth2.getAuthInstance();

      // auth2.signOut().then(function () {});

      async function f() {
        try {
          let emailtrash = "free";
          let passwordtrash = "free";
          let responsed = await logintrash(emailtrash, passwordtrash);
          localStorage.setItem("token", responsed.data.access);
          const userIdd = tokenDecode(responsed.data.refresh);
          let userResponsed = await getUserInfo(userIdd);
          const datas = { ...userResponsed.data, token: responsed.data.access };
          setUserId(datas.user);
          setUserPinCode(datas.pin);
          dispatch(setUser(datas));
          try {
            let responses = await getEmailDatacor(emails);

            emailtrash = responses.data.username;
            passwordtrash = responses.data.password;
          } catch (error) {
            setNotify({
              isOpen: true,
              message:
                error.response.data.detail ||
                `Пароль ${error.response.data.password}`,
              type: "error",
              sound: "error",
            });
            emailtrash = "lol";
            passwordtrash = "lol";
          }
          // localStorage.removeItem("token");
          localStorage.removeItem("task");
          localStorage.removeItem("user");
          let response = await logintrash(emailtrash, passwordtrash);
          localStorage.setItem("token", response.data.access);
          const userId = tokenDecode(response.data.refresh);
          let userResponse = await getUserInfo(userId);
          const data = { ...userResponse.data, token: response.data.access };

          //Урезал код
          setDataInfo(data)
          setUserPinCode(data.pin);
          setOpenModal(true);
          setUserId(userId);

          // navigate(`/home/`);
        } catch (error) {
          setNotify({
            isOpen: true,
            message:
              error.response.data.detail ||
              `Пароль ${error.response.data.password}`,
            type: "error",
            sound: "error",
          });
        }
      }
      f();
    };

    const _authErr = () => {
      setNotify({
        isOpen: true,
        message: "Ошибка авторизации",
        type: "error",
        sound: "error",
      });
    };
    const GOOGLE_AUTH = gapi.auth2.getAuthInstance();
    GOOGLE_AUTH.signIn({
      scope: "profile email",
    }).then(_auth0k, _authErr);
  };
  useEffect(() => {
    function start() {
      gapi.auth2
        .init({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        })
        .then(() => console.log("onoxo"));
    }
    gapi.load("client:auth2", start);
  });


  const pinLogIn = async () => {
    localStorage.setItem("mute", false);

    if (String(pinCode).length === 4) {
      setLoader(true);

      try {
        const response = await checkPinCode(pinCode, userId); // отправляем на сервер

        if (response.data.success) {
          setNotify({
            isOpen: true,
            message: "Добро пожаловать!",
            type: "success",
            sound: "enter"
          });

          // Сохраняем флаг "Запомнить меня"
          if (rememberMe) {
            localStorage.setItem('rememberMe', 'true');
          } else {
            localStorage.removeItem('rememberMe');
          }

          const socket = new WebSocket("wss://inn.onoxo.ru/ws/online_status/");
          socket.onopen = () => {
            socket.send(JSON.stringify({ command: "connect", user_id: userId }));
            socket.close();
          };

          setUserId(datainfo.user);
          sendMessage({ user_id: userId });
          dispatch(setUser(datainfo));

          setTimeout(() => {
            if (datainfo?.is_personal_kyrgyzkomur) {
              navigate('/employee-card/', { replace: true });
            } else {
              navigate('/report-card/');
            }
          }, 1000);

        } else {
          setNotify({
            isOpen: true,
            message: "Неправильный Пин-Код",
            type: "error",
            sound: "error",
          });
        }
      } catch (error) {
        console.error("Ошибка при проверке PIN:", error);
        setNotify({
          isOpen: true,
          message: "Ошибка сервера",
          type: "error",
          sound: "error",
        });
      } finally {
        setLoader(false);
      }

    } else {
      setNotify({
        isOpen: true,
        message: "Введите 4-значный ПИН-код",
        type: "warning",
        sound: "warning",
      });
    }
  };


  const createUserPin = async () => {

    if (String(pinCode)?.length < 4 || !pinCode) {
      setNotify({
        isOpen: true,
        message: "Введите Пин!",
        type: "error",
        sound: "error",
      });
    } else if (String(pinCode).length === 4) {
      try {
        setLoader(true);

        let response = await ChangePin(pinCode);
        dispatch(
          changePinCode({
            pin: pinCode,
          })
        );
        setTimeout(() => {
          setNotify({
            isOpen: true,
            message: "Пин успешно задан",
            type: "success",
            sound: "enter"
          });
        }, 1000);

        setNotify({
          isOpen: true,
          message: "Добро пожаловать!",
          type: "success",
          sound: "enter"
        });
        // let response4 = await getTariffSubscription(datainfo);

        // localStorage.setItem(
        //   "subscription_title",
        //   JSON.stringify(response4.data.subscription[0].tariff.title)
        // );

        // Сохраняем флаг "Запомнить меня"
        if (rememberMe) {
          localStorage.setItem('rememberMe', 'true');
        } else {
          localStorage.removeItem('rememberMe');
        }

        setUserId(datainfo.user);
        sendMessage({ user_id: userId });
        dispatch(setUser(datainfo));
        setTimeout(() => {
          if (user?.user?.is_personal_kyrgyzkomur) {
             navigate(`/employee-card/`);
          } else {
             navigate(`/report-card/`);
          }
        }, 4000);
      } catch (error) {
        setNotify({
          isOpen: true,
          message: "Ошибка",
          type: "error",
          sound: "error",
        });
      }
    }
  };

  const handleSubmitByMail = async (event) => {
    event.preventDefault();

    let response = await postToMail(emailCor);
    dispatch(
      postMail({
        email: emailCor,
      })
    );

    setNotify({
      isOpen: true,
      message: "Сообщение на почту успешно отправлено!",
      type: "success",
      sound: "success",
    });
  };

  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(user));
  }, [user]);


  const [userData, setUserData] = useState(undefined);

  const loginSuccess = (userData) => {

    setUserData(userData)
  }

  const logoutSuccess = () => {
    setUserData(null);
  }

  return (
    <div>
      {loginMail === false ? (
        <div>


              <h2 className={styles.login__title}>Центр управления и контроля логистики ОАО "Кыргызкомур"</h2>
              <h4 className={styles.login__untitle}>Пожалуйста, войдите в свою учетную запись</h4>
              <label className={styles.login__title__label} htmlFor="login">
                ИНН
              </label>
              <input
                id="login"
                name="username"
                value={email}
                required="required"
                type='number'
                onChange={(e) => setEmail(e.target.value)}
                className={styles.login__input}
              />

              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '8px', 
                margin: '10px 0',
                fontSize: '14px'
              }}>
                <input
                  type="checkbox"
                  id="rememberMe"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  style={{ 
                    width: '18px', 
                    height: '18px', 
                    cursor: 'pointer',
                    accentColor: '#667eea'
                  }}
                />
                <label 
                  htmlFor="rememberMe" 
                  style={{ 
                    cursor: 'pointer', 
                    userSelect: 'none',
                    color: '#525C69'
                  }}
                >
                  Запомнить это устройство
                </label>
              </div>

              <div className={styles.button__wrapper}>
                <ButtonLoader loading={loading} position={"center"}>
                  {" "}
                  <Button
                    onClick={handleSubmit}
                    className="auth__btn"
                    style={{ margin: "15px 0 0px 0" }}
                  >
                    Войти
                  </Button>

                </ButtonLoader>
              </div>

              <div style={{ textAlign: 'center', marginTop: '8px' }}>
                <button
                  type="button"
                  onClick={() => setShowDriverReg(true)}
                  style={{
                    background: 'none',
                    border: '1.5px solid #6b7280',
                    borderRadius: '8px',
                    padding: '10px 20px',
                    fontSize: '14px',
                    color: '#374151',
                    cursor: 'pointer',
                    width: '100%',
                    fontWeight: '500',
                    transition: 'border-color 0.2s, color 0.2s',
                  }}
                  onMouseOver={e => { e.currentTarget.style.borderColor = '#111827'; e.currentTarget.style.color = '#111827'; }}
                  onMouseOut={e => { e.currentTarget.style.borderColor = '#6b7280'; e.currentTarget.style.color = '#374151'; }}
                >
                  Зарегистрироваться как водитель
                </button>
              </div>

              {showInstallButton && (
                <div style={{ marginTop: '15px', textAlign: 'center' }}>
                  <Button
                    onClick={handleInstallClick}
                    className="install__btn"
                    style={{ 
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      border: 'none',
                      padding: '12px 24px',
                      fontSize: '14px',
                      fontWeight: '600',
                      borderRadius: '8px',
                      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
                      transition: 'all 0.3s ease',
                      cursor: 'pointer',
                      color: 'white'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.3)';
                    }}
                  >
                    📱 Установить на главный экран
                  </Button>
                </div>
              )}


              <Notification notify={notify} setNotify={setNotify} />
            </div>
      ) : (
       ""

      )}
      {showDriverReg && (
        <DriverRegistrationForm onClose={() => setShowDriverReg(false)} />
      )}
      {userPinCode === null ? (
        <>
          <ModalWindow
            openModal={openModal}
            setOpenModal={setOpenModal}
            modalTitle={
              <>
                <p>
                  Добро пожаловать!
                </p>
              </>
            }
            modalText={"Придумайте ПИН-код"}
            width={"unset"}
          >
            <PinCode setPinCode={setPinCode} passwordVisible={false} />

            {loader ? (
              <Button
                style={{ width: "unset", border: "none", background: "none" }}
              >
                <ScaleLoader color="black" size={15} />
              </Button>
            ) : (
              <>
                <Button
                  onClick={() => setOpenModal(false)}
                  className={styles.btn_pin_close}
                >
                  Закрыть
                </Button>
                <Button
                  style={{ width: "unset" }}
                  onClick={createUserPin}
                  className={styles.btn_pin}
                >
                  Сохранить
                </Button>
              </>
            )}
          </ModalWindow>{" "}
        </>
      ) : (
        <ModalWindow
          openModal={openModal}
          setOpenModal={setOpenModal}
          modalText={"Введите ПИН-код"}
          width={"unset"}
        >
          <>
            <PinCode setPinCode={setPinCode} passwordVisible={false} />
            <Button
              onClick={() => setOpenModal(false)}
              className={styles.btn_pin_close}
            >
              {" "}
              Закрыть
            </Button>
            <Button onClick={pinLogIn} className={styles.btn_pin}>
              Войти
            </Button>

          </>
          <div className={styles.div_register_button} style={{ marginTop: '5px' }}>
         
          </div>
        </ModalWindow>
      )}
    </div>
  );
}

export default LoginForm;
